<template>
    <FooterButton id="currency-button"
                  class="currency-button">
        <template v-if="menuStore.mobileMenuFooterData.isLanguageDropdownDisabled">
            <FiatCurrencySearch v-if="menuStore.mobileMenuFooterData.isLanguageDropdownDisabled"
                                :currentFiatCurrency="menuStore.mobileMenuFooterData.fiatCurrency"
                                :fiatCurrencies="menuStore.mobileMenuFooterData.fiatCurrencies"
                                tooltip-class="tippy-mobile-menu"
                                :isConverter="false"
                                :showModal="menuStore.isCurrencySearchModalOpen && isMobileOrTablet" />
        </template>
        <template v-else>
            <CurrencyLanguageSearch :currentCurrency="menuStore.mobileMenuFooterData.fiatCurrency"
                                    :currencies="menuStore.mobileMenuFooterData.fiatCurrencies"
                                    :locales="menuStore.mobileMenuFooterData.locales as TLocales"
                                    :currentLocale="menuStore.mobileMenuFooterData.currentLocale"
                                    :showModal="menuStore.isCurrencySearchModalOpen && isMobileOrTablet"
                                    :currentRouteUrls="menuStore.mobileMenuFooterData.currentRouteUrls as TCurrentRouteUrls"
                                    :isShort="true" />
        </template>
    </FooterButton>
</template>

<script setup lang="ts">
    import FooterButton from '../../components/FooterButton.vue';
    import { useMenuStore } from '@/js/store/menu/MenuStore';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import FiatCurrencySearch from '../../../top-menu/FiatCurrencySearch.vue';
    import CurrencyLanguageSearch from '../../../top-menu/CurrencyLanguageSearch.vue';
    import { TCurrentRouteUrls, TLocales } from '../../types/menuFooterTypes';

    const menuStore = useMenuStore();

    const { isMobileOrTablet } = useDeviceSize();
</script>

<style scoped lang="scss">
.currency-button {
    font-size: 14px;
    font-weight: 500;
}
</style>
